import { useQuery } from '@tanstack/react-query';

import { playerStatKeys } from '@/hooks/player/playerStatsKeys';
import { getPlayerStats } from '@/infrastructure/network/data/player/player-stats-per-season';
import { useOrganizationStore } from '@/store/organization-store';

export const usePlayerStatsQuery = (teamLeagueUuid: string, seasonUuid: string, playerUuid: string) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: playerStatKeys.playerStats(store.organizationUuid, teamLeagueUuid, seasonUuid, playerUuid),
		queryFn: () => getPlayerStats({ organizationUuid: store.organizationUuid, teamLeagueUuid, seasonUuid, playerUuid }),
		enabled: !!(store.organizationUuid && teamLeagueUuid)
	});
};
